import {ActionReducer} from '@ngrx/store';
import {NGXLogger} from "ngx-logger";

export function storeDebugMiddlewareFactory(logger: NGXLogger) {
  return (reducer: ActionReducer<any>): ActionReducer<any> => {
    return (state, action) => {
      logger.info('state', state);
      logger.info('action', action);
      return reducer(state, action);
    };
  };
}
